import RpcService  from '@/core/services/Rpc/RpcService';
import RpcResponse from '@/core/services/Rpc/RpcResponse';

import type Driver            from '@/domains/Drivers/Driver';
import type RpcDataPagination from '@/core/services/Rpc/RpcDataPagination';
import type RpcDataSort       from '@/core/services/Rpc/RpcDataSort';

/**
 * DAO для работы с водителями
 */
class DriversDAO {

  /**
   * Загружает одного водителя: по id либо избранного водителя текущего пользователя (isFavorite: true)
   */
  static async get(
    filters: {
      id?: number;
      isFavorite?: boolean;
    },
  ): Promise<RpcResponse> {
    return await RpcService.makeRequest('drivers.get', filters);
  }

  /**
   * Загружает список водителей
   */
  static async getList(
    filters?: {
      id?: number;
      vehicleId?: number;
      pattern?: string;
      isFavorite?: boolean;
    },
    pagination?: RpcDataPagination,
    sort?: RpcDataSort,
  ): Promise<RpcResponse> {
    return await RpcService.makeRequest(
      'drivers.getList',
      filters,
      pagination,
      sort,
      true, null, null, false,
      { abortPrevious: true },
    );
  }

  /**
   * Создаёт или обновляет водителя.
   * Бэк определяет add/update по наличию driver.id и возвращает id водителя
   */
  static async upsert(driver: Driver): Promise<RpcResponse> {
    return await RpcService.makeRequest('drivers.upsert', { driver });
  }

  /**
   * Удаляет водителя
   */
  static async delete(id: number): Promise<RpcResponse> {
    return await RpcService.makeRequest('drivers.delete', { id });
  }
}

export default DriversDAO;
